module.exports = __webpack_public_path__ + "img/team-member-2.9dee85df.jpg";